export default "__VITE_ASSET__BXmGfeC5__"